import React from 'react';
import { FacilityProcessingLabel } from './FacilityProcessingLabel';
import { SpeciesVisual } from './SpeciesVisual';
import { FillPowerLeftPanel } from './FillPowerLeftPanel.js';
import { OriginLeftPanel } from './OriginLeftPanel.js';
import { isRenu } from '../utils/ui.utils';
import { DetailCertText } from './DetailCertText';
import { DetailCareText } from './DetailCareText';
import { DetailImpactLeftText } from './DetailImpactLeftText';

export const DetailActiveLeft = ({ activeSection, data, changeWord, t, DEV_MODE, showImpact, impactData }) => {
  return (
    <>
      {activeSection === "CERTIFICATIONS" && (
        <DetailCertText 
          isRsd={data.rsd} 
          isRds={data.rds} 
          isGrs={data.down_type ? isRenu(data.down_type) : false} 
          isTreatment={data.treatment} 
          t={t} // changeWord is not needed for a text component
        />
      )}

      {activeSection === "FP" && (
        <FillPowerLeftPanel t={t} />
      )}
      {activeSection === "ORIGIN" && (
        <OriginLeftPanel origin={data.origin ? data.origin[0] : ""} down_type={data.down_type} t={t} />
      )}
      {activeSection === "CARE" && (
        <DetailCareText t={t} />
      )}
      {activeSection === "SUSTAINABILITY" && (
        <>
          {showImpact && impactData ? (
            <DetailImpactLeftText 
              impactData={impactData} 
              t={t}
            />
          ) : (
            <a id="mr-pow-cta" href="//protectourwinters.org/join-team-pow/?channel=tmd_afd" target="_blank" className="shopify-buy__btn ei">JOIN POW</a>
          )}
        </>
      )}
    </>
  );
};